import $ from 'jquery';

var selectors = {
  popoutWrappper: '[data-popout]',
  popoutList: '[data-popout-list]',
  popoutToggle: '[data-popout-toggle]',
  popoutInput: '[data-popout-input]',
  popoutOptions: '[data-popout-option]',
};

var classes = {
  listVisible: 'popout-list--visible',
};

var sections = {};

class Popout {
  constructor($popout) {
    this.$container = $popout;
    this.$popoutList = this.$container.find(selectors.popoutList);
    this.$popoutToggle = this.$container.find(selectors.popoutToggle);
    this.$popoutInput = this.$container.find(selectors.popoutInput);
    this.$popoutOptions = this.$container.find(selectors.popoutOptions);
    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
  }
  unload() {
    this.$popoutOptions.off();
    this.$popoutToggle.off();
    this.$popoutList.off();
    this.$container.off();
  }

  _connectToggle() {
    this.$popoutToggle.on(
      'click',
      function(evt) {
        var ariaExpanded = ($(evt.currentTarget).attr('aria-expanded') === 'true');
        $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);
        this.$popoutList.toggleClass(classes.listVisible);
      }.bind(this),
    );
  }

  _connectOptions() {
    this.$popoutOptions.on(
      'click',
      function(evt) {
        var $link = $(evt.target).closest('[data-popout-option]');
        if ($link[0].attributes.href.value === '#') {
          evt.preventDefault();
          this._submitForm($(evt.currentTarget).data('value'));
        }
      }.bind(this),
    );
  }

  _onFocusOut() {
    this.$popoutToggle.on(
      'focusout',
      function(evt) {
        var popoutLostFocus = (this.$container.has(evt.relatedTarget).length === 0);

        if (popoutLostFocus) {
          this._hideList();
        }
      }.bind(this),
    );

    this.$popoutList.on(
      'focusout',
      function(evt) {
        var childInFocus = ($(evt.currentTarget).has(evt.relatedTarget).length > 0);
        var isVisible = this.$popoutList.hasClass(classes.listVisible);

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      }.bind(this),
    );

    this.$container.on(
      'keyup',
      function(evt) {
        if (evt.which !== window.theme.keyboardKeys.ESCAPE) { return; }
        this._hideList();
        this.$popoutToggle.focus();
      }.bind(this),
    );

    $('body').on(
      'click',
      function(evt) {
        var isOption = (this.$container.has(evt.target).length > 0);
        var isVisible = this.$popoutList.hasClass(classes.listVisible);

        if (isVisible && !isOption) {
          this._hideList();
        }
      }.bind(this),
    );
  }

  _submitForm(value) {
    this.$popoutInput.val(value);
    this.$container.parents('form').submit();
  }

  _hideList() {
    this.$popoutList.removeClass(classes.listVisible);
    this.$popoutToggle.attr('aria-expanded', false);
  }
}

const popoutSection = {
  onLoad() {
    sections[this.id] = [];
    const wrappers = this.container.querySelectorAll(selectors.popoutWrappper);
    wrappers.forEach(wrapper => {
      const $wrapper = $(wrapper);
      sections[this.id].push(new Popout($wrapper));
    });
  },
  onUnload: function() {
    sections[this.id].forEach(popout => {
      if (typeof popout.unload === 'function') {
        popout.unload();
      }
    });
  },
};

export default popoutSection;
